import { Section } from 'components/section'
import { Animation } from './animation'
import DataWrapperChart from 'components/datawrapper'
import ContactInfo from 'components/contact-info'
import { Parallax } from 'components/parallax'
import Woman from './parallax/woman'
import Silhouettes from './parallax/silouettes'
import Car from './parallax/car'
import { SideFloat, SideText } from './styled'
import { Light } from 'styles/typography'
import { ColoredTitle } from 'components/colored-title'
import OpenLayers from './open-layers'
import { ChapterFooter } from 'components/layout/chapter-footer'
import { authors } from './data'

import coloredTitle_L from './images/ColoredTitle_L.webp'
import coloredTitle_M from './images/ColoredTitle_M.webp'
import coloredTitle_S from './images/ColoredTitle_S.webp'

export const Kyrgyzstan = () => {
  return (
    <>
      <Animation />
      <Section containerType="text">
        <p>
          Насилие в отношении женщин остается одной из самых острых проблем в
          Кыргызстане. По статистике, такое насилие чаще всего совершают мужчины
          в отношении женщин в семьях. За последние годы в стране было несколько
          резонансных случаев истязаний и фемицида.
        </p>
        <p>
          Айзат – одна из переживших издевательства со стороны супруга. Она
          родом из небольшого села на юге Кыргызстана, ее жизнь с ранних лет
          была непростой: потеря отца, брак в молодом возрасте и десять лет
          побоев. Несмотря на пережитое, после долгих лет насилия она смогла
          уйти, забрать детей и начать новую жизнь в другом городе.
        </p>
        <p>
          <Light>
            Предупреждение: в материале присутствуют описания сцен насилия и его
            последствий, а также упоминается тема суицида.
          </Light>
        </p>
        <p>
          Этот материал – часть проекта{' '}
          <a
            href="https://voicesofthebrave.asia/"
            target="_blank"
            rel="noreferrer"
          >
            "Голоса смелых"
          </a>
          , посвященного гендерному насилию в Центральной Азии. Мы рассказываем
          истории женщин, переживших насилие, чтобы показать масштаб проблемы и
          дать голос тем, кто зачастую говорить не может.
        </p>
      </Section>

      <Section containerType="text" heading="Овдоветь в 18 лет">
        <p>
          Айзат росла в небольшой деревне. Когда она была совсем маленькой, ее
          отец погиб, а мать вскоре вышла замуж повторно. Девочка осталась с
          бабушкой, которая старалась дать ей все возможное, но Айзат всегда
          думала о маме.
        </p>
        <p>
          В 18 лет Айзат, как и многие девушки из ее села, вышла замуж. "Я
          согласилась, потому что думала, что так нужно. Все взрослые убеждали,
          что счастье женщины – это выйти замуж и стать матерью", – вспоминает
          она.
        </p>
        <p>
          Но ее первый брак длился всего восемь месяцев. Муж неожиданно погиб в
          автокатастрофе, когда Айзат была на седьмом месяце беременности.
        </p>
        <p>
          "Мой первый муж был человеком, который и мухи не обидит, добрым и
          заботливым. Мы прожили недолгую, но счастливую жизнь, полную взаимного
          уважения", – вспоминает она.
        </p>
        <p>
          После смерти супруга его родные предложили Айзат выйти замуж за его
          младшего брата. Обычай, при котором вдова выходит замуж за брата или
          близкого родственника умершего, известен как "левират". Иногда он
          также практикуется в Кыргызстане.
        </p>
        <p>
          Сначала Айзат категорически отказалась от этого предложения. Но спустя
          год передумала, опасаясь, что ребенок, как и она сама в детстве, будет
          разрываться между семьями матери и покойного отца.
        </p>
        <p>
          "После повторного замужества моей мамы я осталась жить с бабушкой.
          Когда я навещала маму, бабушка часто была недовольна. И с мамой я не
          могла оставаться. Я не хотела, чтобы мой ребенок оказался в такой же
          ситуации, поэтому согласилась на брак, думая, что это [новый супруг]
          все же его родной дядя", – рассказывает она.
        </p>
      </Section>

      <Parallax side="left">
        <Woman />
      </Parallax>

      <Section
        containerType="text"
        heading='"У тебя никого нет, ты сирота. Куда ты вообще можешь уйти?"'
      >
        <p>
          Уже через полгода жизни с новым супругом девушка столкнулась с
          насилием. Сначала ее новый муж Нурлан* (имя изменено) бил ее, будучи
          пьяным. Позже у него вошло в привычку постоянно искать недостатки и
          унижать ее. По словам Айзат, физическое насилие почти всегда
          сопровождалось психологическим.
        </p>
        <p>
          "Нурлан устраивал скандалы даже из-за того, что ботинки стояли не так,
          как ему хотелось. Он не просто бил меня, но и говорил: "У тебя никого
          нет, ты сирота. Куда ты вообще можешь уйти?" А мне действительно
          некуда было пойти. Если бы я ушла к бабушке, ей самой было уже за 80.
          Если бы к маме – у нее была другая семья", – говорит она.
        </p>
        <p>
          В браке у Айзат родилось еще четверо детей. Несколько раз она пыталась
          уйти из дома. Однако, как сама Айзат признается, ей действительно было
          некуда идти с пятью детьми, и в итоге им приходилось возвращаться.
          Каждый раз ее возвращение сопровождалось еще большим психологическим
          давлением и физическим насилием, которое становилось все жестче.
        </p>
        <p>
          "Как-то раз Нурлан разбил бокал и пригрозил убить меня. Я пыталась
          вырвать бокал из его рук, но в процессе порезала себе руки. Вся в
          крови я пошла в больницу, где мне наложили десять швов. Руки болели
          так сильно, что я не могла даже спать. Но даже в этот момент он не
          переставал давить на меня психологически. Наоборот, он издевался надо
          мной за то, что я пыталась уйти, и говорил: "Ты ушла, и что? Куда ты
          пошла? Что сделали твои родственники? Что ты вообще можешь сделать
          сама?" – вспоминает Айзат.
        </p>
        <p>
          В те времена единственной радостью и опорой Айзат были ее дети – они
          будто помогали ей ненадолго забыть о горе.
        </p>
        <p>
          Из-за побоев со стороны мужа и нанесенных травм она дважды обращалась
          в милицию, но оба раза столкнулась с бездействием.
        </p>
        <p>
          "Я до сих пор помню тот день. Я была истощенной, худой, с черным от
          синяков лицом. Один глаз едва не выпал. Когда я рассказала
          милиционерам о случившемся, они возмутились: "Ты такая худая,
          маленькая, и твой муж посмел поднять на тебя руку?!" – и сказали, что
          я должна написать заявление. Я написала. Потом они отправили меня на
          экспертизу и гоняли из кабинета в кабинет. Позже я узнала, что мой муж
          просто заплатил им 5000 сомов. А милиция, в свою очередь, тянула
          время, чтобы синяки на моем лице успели сойти. Потом мне сказали: "У
          вас пятеро детей. Идите домой и живите. В семье такое случается".
        </p>
      </Section>

      <ColoredTitle src={[coloredTitle_S, coloredTitle_M, coloredTitle_L]} />

      <Section containerType="text">
        <p>
          После первого обращения в милицию Нурлан снова избил ее. Она написала
          заявление во второй раз, но в милиции ей не объяснили ее прав и не
          упомянули о существовании охранного ордера.
        </p>
        <p>
          "Тогда я поняла, что милиция не заинтересована в защите моих прав", –
          говорит Айзат.
        </p>
        <p>
          Охранный ордер – это документ, который запрещает агрессору
          приближаться к пострадавшей, контактировать с ней (например, звонить
          или писать сообщения) и в некоторых случаях предписывает покинуть
          совместное жилье.
        </p>
        <p>
          "И в этот раз мой муж заплатил 11 тысяч сомов и снова избежал
          наказания. А мне сказали то же самое: у тебя пятеро детей, живи с
          мужем и помирись. В тот момент я окончательно разочаровалась в
          системе", – вспоминает она.
        </p>
        <p>
          Согласно{' '}
          <a
            href="https://stat.gov.kg/media/publicationarchive/dd79bce2-f315-4956-8fc5-52d3485c6aaf.pdf"
            target="_blank"
            rel="noreferrer"
          >
            данным
          </a>{' '}
          Национального статистического комитета Кыргызской Республики, ежегодно
          регистрируется около 10 тысяч случаев семейного насилия, причем более
          90% пострадавших – женщины. В 2024 году это число{' '}
          <a
            href="https://mvd.gov.kg/domesticViolence/reports/40"
            target="_blank"
            rel="noreferrer"
          >
            увеличилось
          </a>{' '}
          на 32% по сравнению с 2023 годом.
        </p>
        <p>
          Как и в истории Айзат, многие случаи остаются незарегистрированными,
          не попадают в официальную статистику или вовсе остаются без должного
          расследования.
        </p>
        <p>
          Однако, несмотря на увеличение числа зарегистрированных случаев,
          количество дел, направленных в суд, остается крайне незначительным.
          Например, в 2023 году было зарегистрировано 13 104 случая домашнего
          насилия, но лишь 391 дело было передано в суд.
        </p>
        <DataWrapperChart
          title={
            'В 2023 году в суд  передали лишь 3,5% зарегистрированных случаев'
          }
          ariaLabel={'Grouped Columns'}
          id={'datawrapper-chart-iCVrB'}
          src={'https://datawrapper.dwcdn.net/iCVrB/3/'}
          height={'504px'}
        />
        <p>
          Активисты и эксперты{' '}
          <a
            href="https://rus.azattyk.org/a/32892414.html"
            target="_blank"
            rel="noreferrer"
          >
            утверждают
          </a>
          , что реальная картина насилия в отношении женщин гораздо страшнее.
          Женщины зачастую боятся обращаться за помощью, опасаясь осуждения со
          стороны общества, родных или бездействия со стороны органов
          правопорядка.
        </p>
      </Section>

      <Section
        containerType="text"
        heading='"Позвони мне, я обязательно помогу"'
      >
        <p>
          Со временем Айзат все больше замыкалась в себе, становилась
          подавленной и избегала разговоров с семьей и близкими о повторяющемся
          насилии. Те дни запомнились ей как самое темное время ее жизни, когда
          в голове постоянно звучал вопрос: "Как я могу покончить с собой?"
        </p>
        <p>
          "Моя жизнь казалась полностью погруженной во тьму. Я все чаще думала:
          зачем я вообще родилась в этом мире? Постепенно я перестала замечать
          своих детей. Я размышляла о том, что пьют люди, чтобы умереть, и
          однажды даже принесла домой ядовитое вещество", – делится она.
        </p>
        <p>
          Гендерная экспертка Гульжамал Султаналиева отмечает, что суицидальные
          мысли при систематическом насилии являются распространенным явлением.
        </p>
        <p>
          "Молодые женщины и девушки все чаще сталкиваются с суицидальными
          мыслями. Например, в 2023 году в селе Андарак Баткенской области было
          зарегистрировано 10 попыток самоубийств среди женщин (из них шестеро{' '}
          <a
            href="https://rus.azattyk.org/a/32743308.html"
            target="_blank"
            rel="noreferrer"
          >
            умерли
          </a>
          , остальных удалось спасти – ред.) Местные органы выяснили, что
          причиной стало семейное насилие. Такие случаи нередко связаны с
          укоренившимися в обществе стереотипами и искаженными религиозными
          представлениями", – говорит Султаналиева.
        </p>
        <p>
          Женщинам внушают, что они должны полностью подчиняться мужу, объясняет
          она, а родственники часто говорят: "Терпи, это женская судьба". Из-за
          этого женщины не знают, к кому обратиться за помощью.
        </p>
        <p>
          Экспертка также отмечает, что экономическая зависимость часто
          удерживает женщин в насильственных браках. "Они боятся уйти, потому
          что не уверены в своей финансовой независимости. А когда они
          обращаются в правоохранительные органы, те часто отмахиваются словами:
          "Это семейное дело". В результате женщины оказываются в безвыходном
          положении, что нередко приводит их к отчаянию и трагическим решениям",
          – рассказывает Султаналиева.
        </p>
        <p>
          Айзат долгое время никому не говорила о насилии. Но однажды ей
          позвонил младший брат ее покойного отца, и она, собравшись с духом,
          рассказала ему обо всем.
        </p>
        <p>
          "Дядя спросил: "Как ты?" И в тот момент я впервые рассказала все как
          есть. Сказала, что постоянно подвергаюсь насилию, что муж бьет не
          только меня, но и детей, не дает нам покоя. Дядя ответил: "Нурлан
          однажды убьет тебя или сделает инвалидом". Он напомнил, что, если меня
          покалечат, я стану беспомощной, и пострадаю не только я, но и мои
          дети. "Беги от него!" – сказал он. – "Позвони мне, я обязательно
          помогу". Эти слова стали для меня спасением".
        </p>
        <p>С того момента Айзат стала думать о побеге. </p>
      </Section>

      <Parallax side="right">
        <Silhouettes />
      </Parallax>

      <Section containerType="text" heading="Кредит на спасение">
        <p>
          Решиться на побег было по-прежнему страшно. Последней каплей для нее
          стал день, когда Нурлан вернулся домой пьяным и снова стал ее бить. В
          этот раз он не останавливался. Он хватал ее за волосы и бил так, что
          Айзат едва не потеряла сознание.
        </p>

        <p>
          "Я посмотрела на своих детей, которые плакали в комнате, и поняла:
          если я не сделаю этого сейчас, я погибну или останусь инвалидом
          навсегда", – говорит Айзат.
        </p>
        <p>
          Она заранее подготовила все необходимое: спрятала документы, сложила
          одежду детей в небольшие сумки. Когда муж уснул, она вывела детей из
          дома. В темноте ее уже ждал дядя на машине. Он помог ей покинуть
          деревню.
        </p>
        <p>
          Айзат с детьми сначала отправилась к отчиму, который жил в полутора
          часах езды. Но даже там она чувствовала, что это лишь временное
          убежище.
        </p>
        <p>
          "Уже через час после моего побега муж начал меня искать. Нурлан звонил
          без остановки, спрашивал, где я. Я отключила телефон, а на следующий
          день включила и сказала, что болею и просто поехала с детьми к маме на
          каникулы", – рассказывает она.
        </p>
        <p>
          Айзат понимала, что муж будет искать ее, а оставаться у отчима
          означало подвергать опасности не только себя, но и семью. Она решила
          ехать в Бишкек, столицу Кыргызстана. Но у нее не было ни денег на
          дорогу, ни плана, что делать дальше.
        </p>
        <p>
          "Я вспомнила, что раньше помогала свекру брать кредиты в банке, –
          говорит она. – И решила, что это единственный выход". Она позвонила в
          банк и оформила кредит на 30 тысяч сомов ($357 на тот момент). "Я даже
          не думала о том, как буду возвращать эти деньги. В голове была только
          одна мысль: уехать подальше и начать все сначала," – говорит она.
        </p>
        <p>
          С этими деньгами она наняла такси, собрала детей и вместе с матерью
          отправилась в Беловодское – село к востоку от Бишкека. Там жила ее
          тетя, но Айзат не стала говорить ей о случившемся. Она нашла жилье по
          объявлению в сети.
        </p>
        <p>
          "Квартира была маленькой, холодной и сырой. Но для нас это было место,
          где мы могли спать спокойно, не боясь, что в любую минуту ворвется
          муж. Я поняла, что лучше жить бедно, но в безопасности, чем продолжать
          терпеть унижения и страх", – говорит она.
        </p>
      </Section>

      <Section containerType="text" heading='"В этой тишине можно дышать"'>
        <p>
          Через два дня после переезда в Беловодск их нашла тетя. Увидев
          состояние Айзат, она немедленно начала искать помощь и узнала о
          кризисном центре "Сезим".
        </p>
        <p>
          Расположенный в столице Кыргызстана кризисный центр "Сезим" оказывает
          помощь пострадавшим от гендерного и семейного насилия, торговли
          людьми, пожилым людям и беженцам. У центра есть транзитный социальный
          дом, где пострадавшие могут найти приют в рамках двух программ:
          экстренной помощи и долгосрочной поддержки. В центре им предоставляют
          психологическую и юридическую помощь, а также помогают в получении
          квалификации и поиске работы.
        </p>
        <p>
          Согласно данным министерства труда, социального обеспечения и
          миграции, в Кыргызстане{' '}
          <a
            href="https://mlsp.gov.kg/ru/telefony-i-kontakty-krizisnyh-czentrov/"
            target="_blank"
            rel="noreferrer"
          >
            насчитывается
          </a>{' '}
          18 кризисных центров, где женщины, пострадавшие от насилия, могут
          получить помощь.
        </p>
        <SideFloat>
          <OpenLayers />
          {/*<DataWrapperChart
            nomargin={true}
            title="Где найти помощь женщинам, пострадавшим от насилия"
            ariaLabel="Map"
            id="datawrapper-chart-ilWJ9"
            src="https://datawrapper.dwcdn.net/ilWJ9/1/"
            height="400px"
          />*/}
        </SideFloat>
        <SideText>
          <div>
            <p>
              В первое время пребывания в центре Айзат не понимала, как ей могут
              помочь. Она не знала, кто такие психологи. В ее родном селе
              считали, что к психологам ходят исключительно люди с психическими
              расстройствами. Она не верила, что обращение за психологической
              помощью что-то изменит.
            </p>
            <p>
              "Меня оставили в центре и сказали, что это для моего блага. Первые
              два дня я просто отдыхала и пыталась успокоиться. А потом, общаясь
              с психологами, я начала понимать, насколько глубоко я была загнана
              в угол. Я даже не осознавала, как сильно разрушила себя, что была
              готова наложить на себя руки, – делится Айзат. – Через несколько
              дней после нашего приезда я почувствовала, что в этой тишине можно
              дышать. Здесь меня никто не бил, никто не кричал. Впервые за
              долгое время я могла спокойно спать".
            </p>
            <p>
              Дети Айзат тоже начали меняться: раньше средний сын был замкнутым
              и тихим, а дочь боялась любого громкого звука. В кризисном центре
              Айзат наконец услышала их смех во время игр.
            </p>
          </div>
        </SideText>
        <div style={{ clear: 'both' }}></div>
        <p>
          Всего Айзат провела там два месяца. За это время она прошла курс
          психологической помощи, который помог ей пересмотреть свою жизнь и
          стать увереннее. Психологи научили ее не только бороться с внутренними
          страхами, но и смотреть в будущее.
        </p>
        <p>
          "Я впервые задумалась о том, что могу работать, зарабатывать деньги и
          заботиться о своих детях. Раньше я не верила, что это возможно", –
          признается она.
        </p>
        <p>
          После выхода из кризисного центра Айзат вернулась в село Беловодское и
          сняла там небольшую квартиру. Чтобы прокормить себя и детей, она
          бралась за любую сезонную работу: собирала морковь, капусту и
          трудилась на полях.
        </p>
      </Section>

      <Section
        containerType="text"
        heading="Сбросить с себя цепи и не оглядываться назад"
      >
        <p>
          Через несколько месяцев ее нашел Нурлан. Он приехал в село Беловодское
          и поначалу просил вернуться и говорил, что хочет вернуть семью. После
          отказов он "стал угрожать, что наложит на себя руки". Но к этому
          времени Айзат уже была готова защищать себя.
        </p>
        <p>
          "Раньше я бы дрожала от страха, но сейчас я спокойно сказала ему:
          "Если хочешь – умирай. Это твое решение, а не мое. Я возвращаться не
          собираюсь", – говорит она.
        </p>
        <p>
          Айзат вспомнила, что говорили ей психологи в кризисном центре: что
          мужчины часто пытаются манипулировать женщинами через детей. Поэтому
          на угрозу, что он заберет детей, Айзат спокойно ответила: "Забирай,
          если они тебе нужны. Но тебе ведь не нужны ни дети, ни я".
        </p>
        <p>
          Муж уехал, оставив ее в покое. "Он был уверен, что я не выдержу и
          вернусь. Но я знала, что лучше жить в бедности, чем снова терпеть
          насилие", – признается Айзат.
        </p>
        <p>
          После этого она подала на развод. Она понимала, что это единственный
          способ оставить пережитое позади. Процесс растянулся на несколько
          месяцев, но Айзат спокойно ждала и оставалась верной своему решению.
          Когда суд наконец официально расторг брак, она почувствовала сильное
          облегчение.
        </p>
        <p>
          "Я словно сбросила с себя тяжелые цепи. Теперь я могу полностью
          посвятить себя детям и своему будущему, не оглядываясь назад", –
          говорит она.
        </p>
      </Section>

      <Parallax side="left">
        <Car />
      </Parallax>

      <Section
        containerType="text"
        heading='"Молчание делает насилие невидимым"'
      >
        <p>
          Когда новая жизнь в Беловодском стала стабильнее, Айзат пригласили
          работать в тот же кризисный центр, который помог ей – "Сезим". Она
          решила, что будет помогать женщинам, которые также подвергались
          насилию.
        </p>
        <p>
          "Я не сомневалась ни минуты, – рассказывает Айзат. – Это место
          подарило мне новую жизнь, научило верить в себя. Теперь я хочу быть
          тем человеком, который сможет поддержать других женщин, как когда-то
          поддержали меня".
        </p>
        <p>
          Будучи соцработницей, она видит, через что проходят женщины,
          столкнувшиеся с насилием. Каждый день она общается с теми, кто решился
          уйти, и помогает им обрести уверенность в себе. Этот вдохновило ее на
          новую цель – получить высшее образование в области психологии, чтобы
          "лучше понимать, как помочь женщинам, которые боятся или не видят
          выхода". Она признается, что это особенно важно для таких, как она,
          кто родился и живет в деревнях, где мало или почти нет нужной
          информации.
        </p>
        <p>
          Пройдя через годы унижений и боли, Айзат уверена, что молчание только
          усугубляет проблему. Она призывает женщин не закрывать глаза на
          насилие и не терпеть его, какими бы ни были обстоятельства. "Молчание
          делает насилие невидимым. Но чем больше мы будем говорить об этом, тем
          больше женщин поверят, что жизнь без страха возможна", – уверена
          Айзат.
        </p>
        <p>
          "Каждая женщина заслуживает жить спокойно и достойно. Не стоит бояться
          выбирать себя и свое счастье. Только от нас зависит, будем ли мы жить
          в страхе или найдем силы начать новую жизнь", – говорит она.
        </p>
        <p>
          По ее словам, важно искать помощь, даже если кажется, что выхода нет.
          "Я знаю, как страшно сделать первый шаг. Но как только ты решаешься,
          все начинает меняться, – добавляет она. – Важно помнить: никто не
          имеет права унижать или поднимать на вас руку, и это никогда нельзя
          считать нормой".
        </p>
      </Section>
      <ContactInfo />

      <ChapterFooter authors={authors} />
    </>
  )
}
